import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { domain } from '../common/domain';

function Categories() {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [editValues, setEditValues] = useState({}); // Store edited values
  const [isEditing, setIsEditing] = useState({}); // Track which row is being edited

  // Fetch all categories
  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${domain()}?endpoint=categories`);
      setCategories(response.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  // Handle input change for adding new category
  const handleInputChange = (e) => {
    setNewCategory(e.target.value);
  };

  // Add a new category
  const handleAddCategory = async () => {
    if (newCategory.trim()) {
      try {
        const formData = new FormData();
        formData.append("name", newCategory);

        await axios.post(`${domain()}?endpoint=categories`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        fetchCategories();
        setNewCategory("");
      } catch (error) {
        console.error("Error adding category:", error);
      }
    } else {
      alert("Please enter a category name.");
    }
  };

  // Delete a category
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      try {
        await axios.delete(`${domain()}?endpoint=categories&id=${id}`);
        fetchCategories();
      } catch (error) {
        console.error("Error deleting category:", error);
      }
    }
  };

  // Handle input change for editing
  const handleEditChange = (id, value) => {
    setEditValues((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  // Toggle edit mode
  const toggleEdit = (id, name) => {
    setIsEditing((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));

    if (!isEditing[id]) {
      setEditValues((prevState) => ({
        ...prevState,
        [id]: name,
      }));
    }
  };

  // Save the updated category
  const handleSave = async (id) => {
    const newName = editValues[id];
    if (newName && newName.trim()) {
      try {
        const formData = new FormData();
        formData.append("name", newName);
        formData.append("_method", "PUT");

        await axios.post(`${domain()}?endpoint=categories&id=${id}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        fetchCategories();
        toggleEdit(id);
      } catch (error) {
        console.error("Error updating category:", error);
      }
    } else {
      alert("Category name cannot be empty.");
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <div className="p-3 bg-light text-dark rounded" style={{ maxWidth: '600px', margin: '0 auto' }}>
      <h5 className="mb-3 text-center">Categories</h5>

      <div className="d-flex mb-2">
        <input
          type="text"
          className="form-control form-control-sm me-2"
          placeholder="Category name"
          value={newCategory}
          onChange={handleInputChange}
        />
        <button className="btn btn-sm btn-primary" onClick={handleAddCategory}>
          Add
        </button>
      </div>

      <table className="table table-sm table-bordered text-center">
        <thead className="table-light">
          <tr>
            <th>#</th>
            <th>Category</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {categories.length > 0 ? (
            categories.map((category, index) => (
              <tr key={category.id}>
                <td>{index + 1}</td>
                <td>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={editValues[category.id] || category.name}
                    onChange={(e) => handleEditChange(category.id, e.target.value)}
                    disabled={!isEditing[category.id]}
                  />
                </td>
                <td>
                  {isEditing[category.id] ? (
                    <button
                      className="btn btn-sm btn-success me-2"
                      onClick={() => handleSave(category.id)}
                    >
                      Save
                    </button>
                  ) : (
                    <button
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => toggleEdit(category.id, category.name)}
                    >
                      Edit
                    </button>
                  )}
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete(category.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" className="text-muted">
                No categories found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default Categories;
